var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteAlt7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM5.30556 10.4568C5.30556 8.13344 7.189 6.25 9.51235 6.25C9.92656 6.25 10.2623 6.58579 10.2623 7C10.2623 7.41421 9.92656 7.75 9.51235 7.75C8.01743 7.75 6.80556 8.96187 6.80556 10.4568V11.25H9.5C10.4665 11.25 11.25 12.0335 11.25 13V16C11.25 16.9665 10.4665 17.75 9.5 17.75H7.05556C6.08906 17.75 5.30556 16.9665 5.30556 16V10.4568ZM12.8056 10.4569C12.8056 8.13355 14.689 6.2501 17.0124 6.2501C17.4266 6.2501 17.7624 6.58589 17.7624 7.0001C17.7624 7.41432 17.4266 7.7501 17.0124 7.7501C15.5174 7.7501 14.3056 8.96198 14.3056 10.4569V11.2501H17C17.9665 11.2501 18.75 12.0336 18.75 13.0001V16.0001C18.75 16.9666 17.9665 17.7501 17 17.7501H14.5556C13.5891 17.7501 12.8056 16.9666 12.8056 16.0001V10.4569Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteAlt7);
export default __webpack_public_path__ + "static/media/quote-alt-7.f2e2dffe46815633d0581c26b45256f6.svg";
export { ForwardRef as ReactComponent };